import { Routes } from '@angular/router';

import { LayoutComponent } from './pages/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
      },
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'submissions',
        loadComponent: () =>
          import('./pages/submission/submission.component').then((c) => c.SubmissionComponent),
      },
      {
        path: 'board',
        loadComponent: () => import('./pages/board/board.component').then((c) => c.BoardComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./pages/user/user.component').then((c) => c.UserComponent),
      },
      {
        path: 'users/:userId',
        loadComponent: () =>
          import('./pages/user/user-detail/user-detail.component').then(
            (c) => c.UserDetailComponent,
          ),
      },
      {
        path: 'change-requests',
        loadComponent: () =>
          import('./pages/change-requests/change-requests.component').then(
            (c) => c.ChangeRequestsComponent,
          ),
      },
      {
        path: 'auto-approval-history',
        loadComponent: () =>
          import('./pages/auto-approval-history/auto-approval-history.component').then(
            (c) => c.AutoApprovalHistoryComponent,
          ),
      },
      {
        path: 'auto-approval-history/:operationId',
        loadComponent: () =>
          import('./pages/auto-approval-history/auto-approval-history-detail/auto-approval-history-detail.component').then(
            (c) => c.AutoApprovalHistoryDetailComponent,
          ),
      },
    ],
  },
  {
    path: 'guides',
    loadComponent: () =>
      import('./pages/documents/documents.component').then((c) => c.DocumentsComponent),
    children: [
      {
        path: ':slug',
        loadComponent: () =>
          import('./pages/documents/document-renderer/document-renderer.component').then(
            (c) => c.DocumentRendererComponent,
          ),
      },
    ],
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.component').then((c) => c.AuthComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./unauthorized/unauthorized.component').then((c) => c.UnauthorizedComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
